import { render, staticRenderFns } from "./CompanyMultiRestaurantTabRestaurantSummary.vue?vue&type=template&id=69b59842"
import script from "./CompanyMultiRestaurantTabRestaurantSummary.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabRestaurantSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports